import React from "react";
import { CardComponent } from "./card";
import "./stack.css";
const renderStackCard = (card, index, draggable) => {
    const style = {
        transform: `translate(${index * 0.1}em, ${-index * 0.1}em) skew(3deg)`,
        top: 0,
        left: 0,
    };
    return React.createElement(CardComponent, { card: card, disableDrag: !draggable, key: index, style: style });
};
export const Stack = (props) => {
    const stack = props.stack;
    if (stack.length === 0) {
        return null;
    }
    const last10 = stack.slice(-10);
    const pile = last10.map((card, index) => renderStackCard(card, index, index === last10.length - 1));
    const style = {
        left: `${stack[0].position.x}rem`,
        top: `${stack[0].position.y}rem`,
    };
    let className = "stack";
    return (React.createElement("div", { className: className, style: style },
        pile,
        React.createElement("span", { className: "count" }, stack.length)));
};
